import React from 'react';

const PageSize = ({ totalCount, selectedPageSize, onSelectPageSize, setCurrentPage}) => {
    
    const onChangeHandler = (e, num) => {
        e.preventDefault(); 
        onSelectPageSize(num);
        setCurrentPage(1);
    }

    return (<div class="cb-page-size cb-flex-row-break flex-nowrap">
        <span>Show</span>
        <nav aria-label="page size">
            <ul>
                <li>
                    <a href="#" onClick={(e) => onChangeHandler(e, 50)} class={selectedPageSize === 50 ? "cb-no-text-decoration": "cb-active cb-no-text-decoration"}>
                        50
                    </a>
                </li>
                <li>
                    <a href="#" onClick={(e) => onChangeHandler(e, 100)} class={selectedPageSize === 100 ? "cb-no-text-decoration": "cb-active cb-no-text-decoration"}>
                        100
                    </a>
                </li>
                <li>
                    <a href="#" onClick={(e) => onChangeHandler(e, 200)} class={selectedPageSize === 200 ? "cb-no-text-decoration": "cb-active cb-no-text-decoration"}>
                       200
                    </a>
                </li>
            </ul>
        </nav>
        <div>({totalCount} results)</div>
    </div>);
};
  
  export default PageSize;